import { HeroPresenter, BenefitsPresenter, StoryPresenter, EarlyAccessPresenter } from '../features';
import { Footer } from '../shared/components';

/**
 * Home Page Component
 */
export const HomePage = () => {
  return (
    <>
      {/* Section 1: Hero / Newsletter */}
      <HeroPresenter />

      {/* Section 2: Benefits / Value Proposition */}
      <BenefitsPresenter />

      {/* Section 3: Story / Genesis */}
      <StoryPresenter />

      {/* Section 4: Early Access / Conversion */}
      <EarlyAccessPresenter />
      
      {/* Footer with legal links */}
      <Footer />
    </>
  );
};

export default HomePage;
